import { Transition } from "@headlessui/react";
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TWclassNames } from "./Div";

// Global state to track which popup is open
let openPopupId = null;

export const InfoListPopup = (props) => {
  const { t } = useTranslation();
  const { children, info } = props;
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const popupRef = useRef(null);
  const popupId = useRef(Math.random().toString(36).substr(2, 9));

  const handleClick = (e) => {
    e.stopPropagation();
    if (openPopupId && openPopupId !== popupId.current) {
      // Another popup is open, close it first
      openPopupId = null;
    }
    setIsOpen(!isOpen);
    openPopupId = isOpen ? null : popupId.current;
  };

  const handleClickOutside = (e) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(e.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(e.target)
    ) {
      setIsOpen(false);
      openPopupId = null;
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Map over each info (array) - at make a list out of it
  const infoList = info?.map((item, index) => {
    return (
      <li key={index} className="flex flex-col mb-2">
        <span className="font-semibold">{item?.title}</span>
        <span>{item?.value}</span>
      </li>
    );
  });

  return (
    <>
      <div ref={buttonRef} className="relative">
        <button
          onClick={handleClick}
          className="text-xs text-blue-600 hover:text-blue-800"
        >
          {children}
        </button>
        {info?.length > 0 && (
          <Transition
            show={isOpen}
            enter="transition-opacity duration-75"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              ref={popupRef}
              className={TWclassNames(
                "z-50 fixed sm:absolute bg-white rounded-md p-4 shadow-lg border border-gray-200 max-h-[80vh] overflow-y-auto"
              )}
              style={{
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                maxWidth: "400px",
              }}
            >
              <div className="flex flex-col">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="font-semibold text-lg">{t("Info")}</h3>
                  <button
                    onClick={handleClick}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <svg
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <ul className="space-y-2">{infoList}</ul>
              </div>
            </div>
          </Transition>
        )}
      </div>
    </>
  );
};
